export const DEFAULT_SCHEDULE_LOADED_THRU_MESSAGE =
  'The schedule is currently available through {scheduleLoadedThruDate}. Please modify your search dates.';
